import { CoverageStatus } from 'modules/inbound/shared/domain/CoverageStatusTypes';
import { FlowTypes } from './JitFlowTypesDTO';
import {
  CoverageStoppedAtFilter,
  QuantityStockFilter
} from '../../ui/redux/PartCoverageFiltersReducer/types';

interface IdAndNameDTO {
  id: number;
  name: string;
}

type ISequencerDTO = IdAndNameDTO;
type IProviderDTO = IdAndNameDTO;

export interface PartCoverageFiltersDTO {
  family: string[];
  lines: number[];
  tier_1_provider_ids: IProviderDTO[];
  logistic_operators_ids: ISequencerDTO[];
  models: string[];
  inbounders: string[];
  flow_types: FlowTypes;
  sequencer_coverage_status: CoverageStatus;
  prs: string[];
  coverage_stopped_at: CoverageStoppedAtFilter;
  quantity_stock: QuantityStockFilter;
}

class PartCoverageFiltersDataDTO {
  family: string[];
  lines: number[];
  tier_1_provider_ids: IProviderDTO[];
  logistic_operators_ids: ISequencerDTO[];
  models: string[];
  inbounders: string[];
  flow_types: FlowTypes;
  sequencer_coverage_status: CoverageStatus;
  prs: string[];
  coverage_stopped_at: CoverageStoppedAtFilter;
  quantity_stock: QuantityStockFilter;

  constructor({
    family,
    lines,
    tier_1_provider_ids,
    logistic_operators_ids,
    models,
    inbounders,
    flow_types,
    sequencer_coverage_status,
    prs,
    coverage_stopped_at,
    quantity_stock
  }) {
    this.family = family;
    this.lines = lines;
    this.tier_1_provider_ids = tier_1_provider_ids;
    this.logistic_operators_ids = logistic_operators_ids;
    this.models = models;
    this.inbounders = inbounders;
    this.flow_types = flow_types || [];
    this.sequencer_coverage_status = sequencer_coverage_status;
    this.prs = prs;
    this.coverage_stopped_at = coverage_stopped_at;
    this.quantity_stock = quantity_stock;
  }
}

export default PartCoverageFiltersDataDTO;
